import config from '../config';
import { showNotification } from 'react-admin';
import { stringify } from 'query-string';
import { io } from 'socket.io-client';
import { wait } from '../utils';

const env = process.env.REACT_APP_CUSTOM_NODE_ENV;
const URL = config[env].url;
const DELAY = 1000;
export const STATIONS_PAGE_LIMIT = 100;
let latestSnoListRequestId = 0;

const getUrl = () => {
    const permissions = localStorage.getItem('permissions');

    return permissions === 'franchisee' || permissions === 'tester'
        ? `${URL}franchisee/`
        : permissions === 'partner_service'
        ? `${URL}partner_service/`
        : `${URL}admin/`;
};

const getAuthHeaders = () => {
    const token = localStorage.getItem('token');

    return {
        Authorization: `Bearer ${token}`,
    };
};

const getJson = response =>
    response.text().then(text => {
        if (!text) return {};

        try {
            return JSON.parse(text);
        } catch (e) {
            return { message: text };
        }
    });

const getErrorMessage = body => body.message || body.errorMessage || 'что-то пошло не так';

const getRows = response => {
    if (Array.isArray(response)) return response;
    if (Array.isArray(response.rows)) return response.rows;
    if (Array.isArray(response.data)) return response.data;
    if (Array.isArray(response.items)) return response.items;
    if (response.data && Array.isArray(response.data.rows)) return response.data.rows;
    if (response.data && Array.isArray(response.data.items)) return response.data.items;

    return [];
};

const getCount = (response, rows) => {
    if (Array.isArray(response)) return response.length;

    return (
        response.count ||
        response.total ||
        response.totalCount ||
        (response.data &&
            (response.data.count || response.data.total || response.data.totalCount)) ||
        rows.length
    );
};

const normalizeSnoSearchParams = params => {
    const searchQuery =
        typeof params.searchQuery === 'string' ? params.searchQuery.trim() : '';
    const rawSearchQuery =
        typeof params.rawSearchQuery === 'string' ? params.rawSearchQuery.trim() : searchQuery;
    const searchPrefix =
        typeof params.searchPrefix === 'string' ? params.searchPrefix.trim() : '';
    const searchField = rawSearchQuery ? params.searchField : null;

    if (!searchField) {
        return {
            searchField: null,
            searchQuery: '',
            rawSearchQuery: '',
            searchPrefix: '',
            filter: null,
        };
    }

    const filter = {
        field: searchField,
        q: rawSearchQuery || searchQuery,
        ...(searchField === 'sno' && searchQuery ? { sno: searchQuery } : {}),
        ...(searchField === 'holder_prefix' && searchQuery
            ? { holder_prefix: searchQuery }
            : {}),
        ...(searchField === 'holder_short_number' && searchQuery
            ? {
                  holder_short_number: searchQuery,
                  ...(searchPrefix ? { holder_prefix: searchPrefix } : {}),
              }
            : {}),
    };

    return {
        searchField,
        searchQuery,
        rawSearchQuery,
        searchPrefix,
        filter,
    };
};

export const loadSnoList = (dispatch, params = {}) => {
    const {
        offset = 0,
        limit = STATIONS_PAGE_LIMIT,
        append = false,
    } = params;
    const page = params.page || Math.floor(offset / limit) + 1;
    const nextOffset = (page - 1) * limit;
    const requestId = ++latestSnoListRequestId;
    const search = normalizeSnoSearchParams(params);
    const query = search.filter
        ? {
              page,
              limit,
              ...search.filter,
              filter: JSON.stringify(search.filter),
          }
        : {
              page,
              limit,
          };

    dispatch({
        type: 'SNO_LIST_LOADING_START',
    });

    return fetch(`${getUrl()}test/stations?${stringify(query)}`, {
        headers: getAuthHeaders(),
    })
        .then(res =>
            getJson(res).then(body => {
                if (!res.ok) {
                    throw new Error(getErrorMessage(body));
                }

                return body;
            }),
        )
        .then(response => {
            if (requestId !== latestSnoListRequestId) {
                return;
            }

            const rows = getRows(response);
            const count = getCount(response, rows);

            dispatch({
                type: 'SNO_LIST_LOAD',
                payload: {
                    rows,
                    count,
                    offset: nextOffset,
                    limit,
                    append,
                    search: {
                        searchField: search.searchField,
                        searchQuery: search.searchQuery,
                        rawSearchQuery: search.rawSearchQuery,
                        searchPrefix: search.searchPrefix,
                    },
                },
            });
        })
        .catch(() => {
            if (requestId !== latestSnoListRequestId) {
                return;
            }

            dispatch(showNotification('Ошибка: не удалось загрузить список станций', 'warning'));
            dispatch({
                type: 'SNO_LIST_LOADING_END',
            });
        });
};

export const loadSlotsList = (dispatch, selectedDevice) => {
    return fetch(`${getUrl()}test/devices?sno=${selectedDevice}`, {
        headers: getAuthHeaders(),
    })
        .then(res =>
            getJson(res).then(body => {
                if (!res.ok) {
                    throw new Error(getErrorMessage(body));
                }

                return body;
            }),
        )
        .then(slotsList => {
            dispatch({
                type: 'SLOTS_LIST_LOAD',
                payload: slotsList,
            });
        })
        .catch(error => {
            dispatch(
                showNotification(
                    `Ошибка: не удалось загрузить устройства станции (${error.message})`,
                    'warning',
                ),
            );
            dispatch({
                type: 'SLOTS_LIST_ERROR',
            });
        });
    // else
    //     return dispatch({
    //         type: 'SLOTS_LIST_LOAD',
    //         payload: {},
    //     });
};

export const startLoading = dispatch => {
    return dispatch({
        type: 'LOADING_START',
    });
};

export const loadLogsList = (dispatch, active, datetime) => {
    const token = localStorage.getItem('token');
    if (active !== '')
        return fetch(`${getUrl()}test/logs?sno=${active}&datetime=${datetime}`, {
            headers: { Authorization: `Bearer ${token}` },
        })
            .then(res => res.json())
            .then(logsList => {
                dispatch({
                    type: 'LOGS_LIST_LOAD',
                    payload: logsList,
                });
            });
    else
        return dispatch({
            type: 'LOGS_LIST_LOAD',
            payload: [],
        });
};

export const extract = (dispatch, params, state) => {
    const token = localStorage.getItem('token');
    dispatch({ type: 'LOADING_START' });
    return wait(DELAY).then(() =>
        fetch(`${getUrl()}test/extract`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
                sno: params.sno,
                position: params.position,
                dno: params.dno,
                dtype: params.dtype,
            }),
        })
            .then(
                response => dispatch({ type: 'EXTRACT', payload: response }),
                error => dispatch({ type: 'REQUEST_FAILED', error: error })
            )
            .then(() => loadSlotsList(dispatch, state.active))
            .finally(() => dispatch({ type: 'LOADING_END' }))
    );
};

export const open = (dispatch, params) => {
    const token = localStorage.getItem('token');
    dispatch({ type: 'LOADING_START' });
    return wait(DELAY).then(() =>
        fetch(`${getUrl()}test/open`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
                sno: params.sno,
                position: params.position,
            }),
        })
            // .then(
            //   response => dispatch({type: "SHOW_NOTIFICATION", payload: response}),
            //   error => dispatch({type : "REQUEST_FAILED", error : error})
            // )
            .then(response => {
                if (response.status === 200) {
                    dispatch(showNotification('Операция выполнена'));
                } else {
                    dispatch(showNotification('Ошибка: что-то пошло не так', 'warning'));
                }
            })
    );
};

export const choice = (dispatch, sno, socket) => {
    try {
        // socket.emit('subscribe-to-station-logs', sno);
        loadSlotsList(dispatch, sno);
        return dispatch({
            type: 'CHOICE',
            payload: { sno, datetime: Date.now() },
        });
    } catch (e) {
        console.error('Cannnot switch selected station logs', e);
    }
};

export const updateAdminStatus = (dispatch, params, state) => {
    const token = localStorage.getItem('token');
    dispatch({ type: 'LOADING_START' });
    return wait(DELAY)
        .then(() =>
            fetch(`${getUrl()}test/admin_status`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({
                    dno: params.dno,
                    admin_status: params.admin_status,
                }),
            })
                .then(res => res.json())
                .then(device => {
                    dispatch({
                        type: 'ADMIN_STATUS_UPDATED',
                        payload: device,
                    });
                })
        )
        .then(() => loadSlotsList(dispatch, state.active));
};

export const updateConflictStatus = (dispatch, params, state) => {
    const token = localStorage.getItem('token');
    dispatch({ type: 'LOADING_START' });
    return wait(5000)
        .then(() =>
            fetch(`${getUrl()}test/conflict_status`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({
                    dno: params.dno,
                    conflict_status: params.conflict_status,
                }),
            })
                .then(res => res.json())
                .then(device => {
                    dispatch({
                        type: 'CONFLICT_STATUS_UPDATED',
                        payload: device,
                    });
                })
        )
        .then(() => loadSlotsList(dispatch, state.active));
};

export const changeAllStatuses = (dispatch, params, state) => {
    const token = localStorage.getItem('token');
    dispatch({ type: 'LOADING_START' });
    return wait(DELAY).then(() =>
        fetch(`${getUrl()}test/change_all_statuses`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
                sno: params.sno,
                conflict_status: params.conflict_status,
            }),
        }).then(response => {
            if (response.status === 200) {
                dispatch(showNotification('Операция выполнена'));
                loadSlotsList(dispatch, state.active);
            } else {
                dispatch(showNotification('Ошибка: что-то пошло не так', 'warning'));
            }
        })
    );
};

export const connect = (dispatch, active) => {
    const token = localStorage.getItem('token');
    const PATH = config[env].ioPrefix + '/test/logs';

    try {
        const socket = io(`${config[env].ws}`, {
            path: PATH,
            extraHeaders: {
                Authorization: `Bearer ${token}`,
            },
        });

        socket.on('connect', () => {
            if (active) {
                choice(dispatch, active, socket);
            }
            return dispatch({
                type: 'WS_CONNECTED',
                payload: socket,
            });
        });

        socket.on('station-log', data => {
            return dispatch({
                type: 'WS_MESSAGE',
                payload: data,
            });
        });

        socket.on('disconnect', () => {
            return dispatch({
                type: 'WS_CLOSED',
            });
        });
    } catch (e) {
        console.error(`Failed to connect ${PATH}`, e);
    }
};

export const restart = (dispatch, stationId) => {
    dispatch({ type: 'LOADING_START' });
    return wait(DELAY).then(() =>
        fetch(`${getUrl()}test/relink-stations/restart`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...getAuthHeaders(),
            },
            body: JSON.stringify({
                stationId,
            }),
        }).then(response => {
            if (response.status === 200) dispatch(showNotification('Процесс перезагрузки запущен'));
            else dispatch(showNotification('Ошибка: не удалось перезагрузить станцию', 'warning'));
        }).finally(() => {
            dispatch({ type: 'LOADING_END' });
        }),
    );
};

export const canAccessFirmware = (dispatch, sno) => {
    return fetch(
        `${getUrl()}test/relink-stations/can_access_firmware?sno=${encodeURIComponent(sno)}`,
        {
            headers: getAuthHeaders(),
        },
    )
        .then(response => {
            if (!response.ok) {
                return false;
            }

            return getJson(response).then(data => !!data.canAccess);
        })
        .catch(() => false);
};

export const getFirmwareVersion = (dispatch, sno) => {
    dispatch({ type: 'LOADING_START' });

    return fetch(`${getUrl()}test/relink-stations/get_firmware_version`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            ...getAuthHeaders(),
        },
        body: JSON.stringify({
            sno,
        }),
    })
        .then(response =>
            getJson(response).then(body => {
                if (!response.ok) {
                    throw new Error(getErrorMessage(body));
                }

                dispatch({
                    type: 'FIRMWARE_VERSION_UPDATED',
                    payload: {
                        sno,
                        firmware_version: body.data,
                        firmware_version_updated: new Date().toISOString(),
                    },
                });
                dispatch(showNotification('Версия прошивки получена'));
                return body.data;
            }),
        )
        .catch(error => {
            dispatch(
                showNotification(
                    `Ошибка: не удалось получить версию прошивки (${error.message})`,
                    'warning',
                ),
            );
            throw error;
        })
        .finally(() => {
            dispatch({ type: 'LOADING_END' });
        });
};

export const loadFirmwareFiles = dispatch => {
    return fetch(`${getUrl()}test/relink-stations/get_firmware_update_files`, {
        headers: getAuthHeaders(),
    })
        .then(response =>
            getJson(response).then(body => {
                if (!response.ok) {
                    throw new Error(getErrorMessage(body));
                }

                return Array.isArray(body) ? body : [];
            }),
        )
        .catch(error => {
            dispatch(
                showNotification(
                    `Ошибка: не удалось загрузить список прошивок (${error.message})`,
                    'warning',
                ),
            );
            throw error;
        });
};

export const getApkVersion = (dispatch, sno) => {
    dispatch({ type: 'LOADING_START' });

    return fetch(`${getUrl()}test/relink-stations/get_apk_version`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            ...getAuthHeaders(),
        },
        body: JSON.stringify({
            sno,
        }),
    })
        .then(response =>
            getJson(response).then(body => {
                if (!response.ok) {
                    throw new Error(getErrorMessage(body));
                }

                dispatch({
                    type: 'APK_VERSION_UPDATED',
                    payload: {
                        sno,
                        apk_version: body.data,
                        apk_version_updated: new Date().toISOString(),
                    },
                });
                dispatch(showNotification('Версия APK получена'));
                return body.data;
            }),
        )
        .catch(error => {
            dispatch(
                showNotification(
                    `Ошибка: не удалось получить версию APK (${error.message})`,
                    'warning',
                ),
            );
            throw error;
        })
        .finally(() => {
            dispatch({ type: 'LOADING_END' });
        });
};

export const loadApkFiles = dispatch => {
    return fetch(`${getUrl()}test/relink-stations/get_apk_update_files`, {
        headers: getAuthHeaders(),
    })
        .then(response =>
            getJson(response).then(body => {
                if (!response.ok) {
                    throw new Error(getErrorMessage(body));
                }

                return Array.isArray(body) ? body : [];
            }),
        )
        .catch(error => {
            dispatch(
                showNotification(
                    `Ошибка: не удалось загрузить список APK (${error.message})`,
                    'warning',
                ),
            );
            throw error;
        });
};

export const updateApk = (dispatch, sno, fileId) => {
    dispatch({ type: 'LOADING_START' });

    return fetch(`${getUrl()}test/relink-stations/update_apk_version`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            ...getAuthHeaders(),
        },
        body: JSON.stringify({
            sno,
            fileId,
        }),
    })
        .then(response =>
            getJson(response).then(body => {
                if (!response.ok) {
                    throw new Error(getErrorMessage(body));
                }

                dispatch({
                    type: 'APK_VERSION_UPDATED',
                    payload: {
                        sno,
                        apk_version: null,
                        apk_version_updated: null,
                    },
                });
                dispatch(showNotification('Обновление APK запущено'));
                return body;
            }),
        )
        .catch(error => {
            dispatch(
                showNotification(
                    `Ошибка: не удалось запустить обновление APK (${error.message})`,
                    'warning',
                ),
            );
            throw error;
        })
        .finally(() => {
            dispatch({ type: 'LOADING_END' });
        });
};

export const updateFirmware = (dispatch, sno, fileId) => {
    dispatch({ type: 'LOADING_START' });

    return fetch(`${getUrl()}test/relink-stations/update_firmware_version`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            ...getAuthHeaders(),
        },
        body: JSON.stringify({
            sno,
            fileId,
        }),
    })
        .then(response =>
            getJson(response).then(body => {
                if (!response.ok) {
                    throw new Error(getErrorMessage(body));
                }

                dispatch({
                    type: 'FIRMWARE_VERSION_UPDATED',
                    payload: {
                        sno,
                        firmware_version: null,
                        firmware_version_updated: null,
                    },
                });
                dispatch(showNotification('Обновление прошивки (OTA) запущено'));
                return body;
            }),
        )
        .catch(error => {
            dispatch(
                showNotification(
                    `Ошибка: не удалось запустить обновление прошивки (OTA) (${error.message})`,
                    'warning',
                ),
            );
            throw error;
        })
        .finally(() => {
            dispatch({ type: 'LOADING_END' });
        });
};

export const disconnect = (dispatch, socket) => {
    try {
        socket.disconnect();
        return dispatch({
            type: 'WS_CLOSE',
        });
    } catch (e) {
        console.error(e);
    }
};
